export const state = {
  commune: undefined,
  communes: [],
  sousCommune: undefined,
  sousCommunes: []
}